import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
`

export const Title = styled.h3`
  margin-bottom: 25px;
  font-size: 1.8rem;
  color: #fff;
`

